import React, { useState, useCallback, useEffect } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { TextField, Checkbox, CircularProgress } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { useVeiculoService } from 'hooks/useVeiculoService'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectVeiculo = (props) => {
  const veiculoService = useVeiculoService()
  const [veiculos, setVeiculos] = useState(null)
  const { veiculosExternos, setVeiculosExternos, setProcessando, label, idCaso } = props
  const [listaOpcoesVeiculosFiltros, setListaOpcoesVeiculosFiltros] = useState([])
  const [inputVeiculo, setInputVeiculo] = useState(null)

  const fetchVeiculos = useCallback(async () => {
    const exclude =  idCaso ? await veiculoService.listarVeiculosDeCasoAsync(idCaso, setProcessando) : []
    const response = await veiculoService.listarVeiculos(setProcessando)
    const filteredResponse = response.filter((veiculo) => !exclude.some((excluido) => excluido.id === veiculo.id))
    setVeiculos(filteredResponse)
  }, [idCaso])

  useEffect(() => {
    fetchVeiculos()
  }, [fetchVeiculos])

  const handleChangeInputVeiculo = useCallback(
    (value) => {
      setInputVeiculo(value)
      if (veiculos) {
        if (value?.length > 2) {
          setListaOpcoesVeiculosFiltros((prevState) =>
            veiculos.filter((veiculo) => {
              if (veiculo.identificador?.toUpperCase().includes(value?.toUpperCase()) || veiculo.placa?.toUpperCase().includes(value?.toUpperCase())) {
                return veiculo
              }
            })
          )
        } else {
          setListaOpcoesVeiculosFiltros([])
        }
      }
    },
    [veiculos]
  )

  return (
    <AutocompleteNative
      value={veiculosExternos}
      name="veiculo"
      disabled={veiculos === null || veiculos.length === 0}
      loading={veiculos === null}
      loadingText="Carregando..."
      noOptionsText="Sem informações"
      required
      multiple
      options={listaOpcoesVeiculosFiltros || []}
      onChange={(event, newValue) => {
        setVeiculosExternos(newValue)
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `VEÍCULO ${option.identificador?.toUpperCase()} - ${option.placa?.toUpperCase()}`}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{
              marginRight: 8,
            }}
            checked={selected}
          />
          {`VEÍCULO - ${option.identificador?.toUpperCase()} / PLACA: ${option.placa.toUpperCase()}`}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          InputLabelProps={{
            shrink: true,
          }}
          value={inputVeiculo}
          onChange={(e) => handleChangeInputVeiculo(e.target.value)}
          onPaste={(e) => {
            const pastedText = e.clipboardData.getData('text')
            setInputVeiculo(pastedText)
            handleChangeInputVeiculo(pastedText)
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {veiculos === null && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          placeholder={veiculos === null ? 'Carregando...' : ''}
        />
      )}
    />
  )
}
